import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useCurrencyLocalizer } from "../../hooks/useCurrencyLocalizer";
import { TypographyWithOverflowTooltip } from "../Typographies/TypographyWithOverflowTooltip";
export const GiftCardOrderSummary = ({ amount, email, to, from, message, deliveryDate, }) => {
    const { localizedCurrencyText } = useCurrencyLocalizer(amount);
    return (_jsxs(Grid, Object.assign({ container: true }, { children: [_jsx(GiftCardLineItem, { label: "From", value: from }), _jsx(GiftCardLineItem, { label: "To", value: to }), _jsx(GiftCardLineItem, { label: "Email", value: email }), _jsx(GiftCardLineItem, { label: "Amount", value: localizedCurrencyText }), _jsx(GiftCardLineItem, { label: "Delivery date", value: deliveryDate.format("l") }), _jsx(MessageSummaryItem, { label: "Message", value: message })] })));
};
/**
 * Displays the label and value on one line. Label is left aligned, value is right aligned.
 *
 * @param label
 * @param value
 * @returns
 */
export const GiftCardLineItem = ({ label, value }) => {
    return (_jsxs(_Fragment, { children: [_jsx(Grid, Object.assign({ item: true, xx: 4 }, { children: _jsx(Typography, Object.assign({ variant: "body2", fontWeight: "bold" }, { children: label })) })), _jsx(Grid, Object.assign({ item: true, xx: 8 }, { children: _jsx(TypographyWithOverflowTooltip, Object.assign({ typographyProps: { variant: "body2", textAlign: "end" } }, { children: value })) }))] }));
};
/**
 * Displays the label and value on separate lines. Label and value are left aligned
 *
 * @param label
 * @param message
 * @returns
 */
export const MessageSummaryItem = ({ label, value }) => {
    return (_jsxs(_Fragment, { children: [_jsx(Grid, Object.assign({ item: true, xx: 12 }, { children: _jsx(Typography, Object.assign({ variant: "body2", fontWeight: "bold" }, { children: label })) })), _jsx(Grid, Object.assign({ item: true, xx: 12 }, { children: _jsx(Typography, Object.assign({ variant: "body2" }, { children: value })) }))] }));
};
